var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.186,
    height: 16.251,
    viewBox: "0 0 15.186 15.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(-105.058 -257.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_965",
    "data-name": "Path 965",
    transform: "translate(-6399.349 -490.251)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6504.407,763.288v-9.4l7.428-5.851,7.757,5.851v9.4Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6519.0927734375 762.7879028320312 L 6519.0927734375 754.1365356445312 L 6511.84228515625 748.66796875 L 6504.9072265625 754.1300659179688 L 6504.9072265625 762.7879028320312 L 6519.0927734375 762.7879028320312 M 6519.5927734375 763.2879028320312 L 6504.4072265625 763.2879028320312 L 6504.4072265625 753.8873901367188 L 6511.83544921875 748.0367431640625 L 6519.5927734375 753.8873901367188 L 6519.5927734375 763.2879028320312 Z",
    stroke: "none",
    fill: "#29a19c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    transform: "translate(110.72 267.213)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.994,
    height: 5.81,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 3.494,
    height: 5.31,
    rx: 0.75,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.6d494aafda7c5e43743f9696d71fa5ea.svg";
export { ForwardRef as ReactComponent };